<style scoped="scoped">
	*{
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}
    iframe{
        height:100%;
        width:100%;
        border: none;
    }
</style>

<template>
    <iframe :src="src"></iframe>
</template>

<script>
  import autoLogin from '../../util/autoLogin'
	export default {
		components:{

		},
		props:[],
		data() {
			return {

			}
		},
		computed: {
            src(){
                let enp=autoLogin.makeEnP(this.$store.state.userInfo.phone)
                return "https://s.eggi.cn/pub/index.html?"+enp
            }
		},
		mounted() {

		},
		methods: {

		}
	}
</script>
